import React from 'react';
import { useSelector } from 'react-redux';
import Icon from './Icon';
import Title from './Title';
import Summary from './Summary';

export default function Collapsed() {
  const selectedOption = useSelector(state => state.checkout.shippingOption);

  return selectedOption ? (
    <Summary shippingOption={selectedOption} />
  ) : (
    <>
      <Icon />
      <Title />
    </>
  );
}
